const TestPage = () => {
  return <div>{window.location.hostname}</div>
}

export default TestPage
